/* eslint-disable */
import {BaseInterfApi} from 'unityrpcjs/unityrpc.js'

import * as Comm from "rpc/Comm/Comm"
export var TYPE_VCODE_LOGIN = "login";
export var TYPE_VCODE_CHANGEMOBILE = "changemobile";
export var TYPE_VCODE_BINDMOBILE = "bindmobile";

export class User {
    constructor() {
        this.userid = 0;  // 0 require
        this.username = "";  // 1 require
        this.email = "";  // 2 require
        this.is_active = false;  // 3 require
        this.date_joined = null;  // 4 require
        this.mobile = "";  // 5 require
        this.role = "";  // 6 require
        this.nickname = "";  // 7 require
        this.companyid = 0;  // 8 require
        this.shopids = [];  // 9 require
        this.avatar = "";  // 10 require
        this.wx_unionid = "";  // 11 require
        this.wx_openid = "";  // 12 require
        this.permissions = [];  // 13 require
        this.isBoundCompany = false;  // 14 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

User.__json_class__ = 'Login.User'

export class UserBasic {
    constructor() {
        this.userid = 0;  // 0 require
        this.username = "";  // 1 require
        this.email = "";  // 2 require
        this.is_active = false;  // 3 require
        this.date_joined = null;  // 4 require
        this.mobile = "";  // 5 require
        this.role = "";  // 6 require
        this.nickname = "";  // 7 require
        this.companyid = 0;  // 8 require
        this.avatar = "";  // 9 require
        this.wx_unionid = "";  // 10 require
        this.wx_openid = "";  // 11 require
        this.permissions = [];  // 12 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

UserBasic.__json_class__ = 'Login.UserBasic'

export class UserIn {
    constructor() {
        this.userid = 0;  // 0 require
        this.username = "";  // 1 optional
        this.nickname = "";  // 2 optional
        this.wx_openid = "";  // 3 optional
        this.wx_unionid = "";  // 4 optional
        this.avatar = "";  // 5 optional
    }

    dump() {
        return JSON.stringify(this);
    }
}

UserIn.__json_class__ = 'Login.UserIn'

export class OAuthResult {
    constructor() {
        this.access_token = "";  // 0 require
        this.token_type = "";  // 1 require
        this.expires_in = 0;  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

OAuthResult.__json_class__ = 'Login.OAuthResult'

export class LoginInterfApi extends BaseInterfApi {
    constructor(baseUrl, moduleName='Login',
            interfName='LoginInterf', token='anonymous', ...args) {
        super(baseUrl, moduleName, interfName, token, ...args)
    }


    loginByUsername(username,password, context) {
        let params = {
            username: username,
            password: password,
            };
        let req = this.createRequest('loginByUsername', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('loginByUsername'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    loginByMobile(mobile,password, context) {
        let params = {
            mobile: mobile,
            password: password,
            };
        let req = this.createRequest('loginByMobile', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('loginByMobile'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    loginByPassword(name,password, context) {
        let params = {
            name: name,
            password: password,
            };
        let req = this.createRequest('loginByPassword', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('loginByPassword'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    loginByMobileVCode(mobile,vcode, context) {
        let params = {
            mobile: mobile,
            vcode: vcode,
            };
        let req = this.createRequest('loginByMobileVCode', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('loginByMobileVCode'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    loginByWxCode(code, context) {
        let params = {
            code: code,
            };
        let req = this.createRequest('loginByWxCode', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('loginByWxCode'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getUser( context) {
        let params = {
            };
        let req = this.createRequest('getUser', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getUser'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    setPassword(password, context) {
        let params = {
            password: password,
            };
        let req = this.createRequest('setPassword', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('setPassword'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    changeMobile(mobile,vcode, context) {
        let params = {
            mobile: mobile,
            vcode: vcode,
            };
        let req = this.createRequest('changeMobile', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('changeMobile'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getMobileVCode(type,mobile, context) {
        let params = {
            type: type,
            mobile: mobile,
            };
        let req = this.createRequest('getMobileVCode', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getMobileVCode'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getMobileVCodeV2(type,mobile, context) {
        let params = {
            type: type,
            mobile: mobile,
            };
        let req = this.createRequest('getMobileVCodeV2', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getMobileVCodeV2'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getUserById(userid, context) {
        let params = {
            userid: userid,
            };
        let req = this.createRequest('getUserById', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getUserById'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getUserByMobile(mobile, context) {
        let params = {
            mobile: mobile,
            };
        let req = this.createRequest('getUserByMobile', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getUserByMobile'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getUserByUsername(username, context) {
        let params = {
            username: username,
            };
        let req = this.createRequest('getUserByUsername', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getUserByUsername'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updateUser(user, context) {
        let params = {
            user: user,
            };
        let req = this.createRequest('updateUser', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updateUser'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

}


// WEBPACK FOOTER //
// ./src/apis/rpc/Login/Login.js